import { createWebappRoute } from '@/router/helpers';

export default [
  // "gopro": "gopro",
  createWebappRoute({
    path: '/gopro',
    name: 'gopro-module',
    component() {
      console.log('ROUTER, gopro');

      $dt.showUpgradeModal();

      return {};
    },
  }),
];
